import { observer, useTranslation } from "../vendor/api.js"; // Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 95034, offsets 189248:191539. Structure and names inferred from code, not screenshots.
import * as PlatformModule from "../config/platform.js";
import * as AnalyticsContext from "../analytics/AnalyticsProvider.jsx";
import * as EnvironmentModule from "../config/environment.js";
let Component = observer(() => {
    let { t: translate } = useTranslation(),
      { openInviteCodeModal: openInviteCodeModal } = PlatformModule.inviteStore,
      i = (0, EnvironmentModule.y)(),
      { track: track } = (0, AnalyticsContext.useAnalytics)();
    return (
      <div className={"w-full"}>
        <div
          className={
            "bg-white border border-[var(--color-border-warm)] flex flex-col gap-[6px] items-start p-[8px] rounded-[6px] w-full drop-shadow-[0px_0px_1.5px_rgba(0,0,0,0.05)]"
          }
        >
          <div
            className={
              "bg-[var(--color-surface-hover)] h-[50px] rounded-[6px] w-full flex items-center justify-center overflow-clip"
            }
          >
            <svg
              width={"24"}
              height={"24"}
              viewBox={"0 0 16 16"}
              fill={"none"}
              xmlns={"http://www.w3.org/2000/svg"}
            >
              <path
                d={
                  "M10.0033 1.33545C11.476 1.33545 12.6699 2.52936 12.6699 4.00212C12.6699 4.48814 12.5399 4.94379 12.3127 5.33619L15.3366 5.33545V6.66878H14.0033V13.3354C14.0033 13.7036 13.7048 14.0021 13.3366 14.0021H2.66992C2.30174 14.0021 2.00326 13.7036 2.00326 13.3354V6.66878H0.669922V5.33545L3.69377 5.33619C3.46662 4.94379 3.33659 4.48814 3.33659 4.00212C3.33659 2.52936 4.5305 1.33545 6.00326 1.33545C6.80007 1.33545 7.51527 1.68492 8.00387 2.23896C8.49127 1.68492 9.20647 1.33545 10.0033 1.33545ZM7.3366 6.66878H3.33659V12.6688H7.3366V6.66878ZM12.6699 6.66878H8.66994V12.6688H12.6699V6.66878ZM6.00326 2.66878C5.26688 2.66878 4.66992 3.26574 4.66992 4.00212C4.66992 4.70502 5.21384 5.28089 5.90375 5.33179L6.00326 5.33545H7.3366V4.00212C7.3366 3.33435 6.84574 2.78124 6.20511 2.68396L6.10277 2.67244L6.00326 2.66878ZM10.0033 2.66878C9.30034 2.66878 8.72447 3.2127 8.6736 3.90261L8.66994 4.00212V5.33545H10.0033C10.7061 5.33545 11.282 4.79153 11.3329 4.10162L11.3366 4.00212C11.3366 3.26574 10.7397 2.66878 10.0033 2.66878Z"
                }
                fill={"#1A1A1A"}
              />
            </svg>
          </div>
          <div className={"flex flex-col gap-[6px] w-full"}>
            <button
              type={"button"}
              className={
                "bg-black flex h-[28px] items-center justify-center rounded-[6px] w-full text-[12px] leading-[22px] text-white cursor-pointer border-none"
              }
              onClick={() => {
                (track("track", "invite_friend_click", {}),
                  openInviteCodeModal());
              }}
            >
              {translate(
                i ? "invite.inviteFriend" : "invite.inviteFriendNoRegister",
              )}
            </button>
          </div>
        </div>
      </div>
    );
  }),
  LanguageToggle = observer(() => (
    <div className={"flex flex-col items-start w-full"}>
      <Component />
    </div>
  ));
export { LanguageToggle };
